import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Typography } from '@material-ui/core';

const styles = theme => ({
  root: {
    width: "auto",
  },
});

class TreasureRenderer extends Component {
  render() {
    if (!this.props.treasures) return null;

    const { classes } = this.props;

    const resultRows = this.props.treasures.map((value, index) => {
      return (
        <TableRow key={index}>
          <TableCell>{index + 1}</TableCell>
          <TableCell>
            {value.coins.map((value, index) => <Typography key={index}>{value}</Typography>)}
          </TableCell>
          <TableCell>
            {value.valuables ? value.valuables.map((value, index) => <Typography key={index}>{value.quantity > 1 ? value.quantity + "x " : ""}{value.item}</Typography>) : ""}
          </TableCell>
          <TableCell>
            {value.items ? value.items.map((value, index) => <Typography key={index}>{value.quantity > 1 ? value.quantity + "x " : ""}{value.item}</Typography>) : ""}
          </TableCell>
        </TableRow>
      );
    });

    return (
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Row</TableCell>
              <TableCell>Coins</TableCell>
              <TableCell>Valuables</TableCell>
              <TableCell>Items</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{resultRows}</TableBody>
        </Table>
      </Paper>
    );
  }
}

TreasureRenderer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TreasureRenderer);


// WEBPACK FOOTER //
// ./src/treasure-generator/TreasureRenderer.js